import { SortableContext } from '@dnd-kit/sortable'
import { StructuredDataSchemaItem } from '@repo/shared/dtos/structured-data'
import { useT } from '@repo/ui/hooks'
import { GripVerticalIcon } from 'lucide-react'

import { buildId, UNPLACED_SECTION_ID } from '@/components/admin/structure-data/display/helpers'
import { Sortable } from '@/components/admin/structure-data/display/Sortable'

export function UnplacedItemsSection({
  unplacedItems,
}: {
  unplacedItems: StructuredDataSchemaItem[]
}) {
  const { t } = useT()
  return (
    <div className="border-primary-100 bg-primary-50/30 flex items-start gap-2 rounded-lg border border-dashed pb-4">
      <main className="flex-1">
        <header className="border-primary-50 mb-4 flex items-center gap-4 rounded-lg border-b px-4 py-2">
          <h1 className="text-primary-600 text-lg font-medium">
            {t('admin.structuredData.unplacedItems', { cfl: true, defaultValue: 'Unplaced Items' })}
          </h1>
        </header>
        <SortableContext items={unplacedItems.map((item) => buildId(UNPLACED_SECTION_ID, item.id))}>
          <div className="flex flex-wrap gap-2 px-4">
            {unplacedItems.length > 0 ? (
              unplacedItems.map((item, itemIndex) => (
                <Sortable
                  className="max-w-fit"
                  key={buildId(UNPLACED_SECTION_ID, item.id)}
                  id={buildId(UNPLACED_SECTION_ID, item.id)}
                >
                  {({ attributes, listeners }) => (
                    <div
                      className="border-primary-200 bg-primary-100/50 hover:bg-primary-200 hover:border-primary-300 flex w-fit items-center gap-1 rounded-md border px-2 py-1 transition-colors"
                      {...listeners}
                      {...attributes}
                    >
                      <GripVerticalIcon className="text-primary-400 size-5" />
                      <div className="flex items-center gap-2">
                        <div className="text-base font-medium text-orange-500">{itemIndex + 1}</div>
                        <div className="text-sm">{item.label}</div>
                      </div>
                    </div>
                  )}
                </Sortable>
              ))
            ) : (
              <span className="text-primary/50">
                {t('admin.structuredData.unplacedItemsEmpty')}
              </span>
            )}
          </div>
        </SortableContext>
      </main>
    </div>
  )
}
